<ng-container *ngIf="initialData">
  <article class="container">
    <ifbp-submission-details-header-section class="section-container"
                                            [data]="initialData.headerData">
    </ifbp-submission-details-header-section>

    <ifbp-submission-details-banner-section class="section-container"
                                            *ngIf="initialData.bannerData"
                                            [data]="initialData.bannerData">
    </ifbp-submission-details-banner-section>

    <ifbp-form-details-section class="section-container"
                               [submissionForm]="submissionForm"
                               [documentsData]="documentsData">
    </ifbp-form-details-section>

    <ifbp-submission-details-footer-section class="section-container"
                                            [appBarActionsData]="initialData.appBarActions"
                                            (appBarActionInvoke)="onAppBarActionInvoke($event)">
    </ifbp-submission-details-footer-section>
  </article>
</ng-container>
